module.exports = __webpack_public_path__ + "img/smartwatch.0d5e74af.svg";